import { CommunicationFlowType, IClinicNumber } from '@dataTypes/clinic.type'
import { safeParseMethods } from '@utils/phoneManagement.utils'

export const flowTypeLabel = (
  flowType?: CommunicationFlowType | null,
): string => (flowType === 'sms' ? 'SMS flow' : 'Call flow')

export const clinicNumberEligibleForFlow = (
  number: IClinicNumber,
  flowType: CommunicationFlowType,
): boolean => {
  if (number.status !== 'Active') return false
  const methods = safeParseMethods(number.contact_methods).map((method) =>
    method.toLowerCase(),
  )
  if (flowType === 'sms') {
    return methods.includes('sms') && number.functions_send_sms === true
  }
  return methods.includes('call')
}

export const stripSmsMarkup = (value?: string | null): string => {
  if (value == null) return ''
  return value
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

/** Styled editor value plus the plain text an SMS send should use. */
export const smsMessagePair = (
  messageHtml?: string | null,
  message?: string | null,
): { messageHtml?: string; message: string } => {
  const hasHtml = messageHtml != null && messageHtml !== ''
  const source = hasHtml ? messageHtml : (message ?? '')
  return {
    messageHtml: hasHtml ? messageHtml : undefined,
    message: stripSmsMarkup(source),
  }
}
